import React from "react";
import aderantTheme from "../../Theme/AderantTheme";
export const StatusIcon = (props) => {
    const { className, diameter = aderantTheme.typography.pxToRem(12), id, color, style } = props;
    return (React.createElement("span", { "aria-label": props["aria-label"], id: id, className: className, style: {
            height: diameter,
            width: diameter,
            borderRadius: "50%",
            backgroundColor: color,
            display: "inline-block",
            ...style
        } }));
};
